//@ts-ignore
import { DashboardLayout as DashboardLayoutService } from '@careinfo/layout';
import { Outlet } from 'react-router-dom';
import BranchIcon from '../Icons/BranchIcon';
import DeliveryIcon from '../Icons/DeliveryIcon';
import ManifestIcon from '../Icons/ManifestIcon';
import MerchantIcon from '../Icons/MerchantIcon';
import OverViewIcon from '../Icons/OverViewIcon';
import PickUpRequest from '../Icons/PickUpRequest';
import RiderIcons from '../Icons/RiderIcons';
import RunsheetIcon from '../Icons/RunsheetIcon';
//@ts-ignore
import { tw } from '@careinfo/tailwind';
import { getKey } from '../helpers/sessionKey';
import WelcomeIcon from '../Icons/WelcomeIcon';

export const shouldShowWelcome = getKey('shouldShowWelcome');
export const navigation: any = [
  {
    name: 'Courier',
    href: '',
    icon: '',
    children: [
      ...(shouldShowWelcome === 'true' || shouldShowWelcome === null
        ? [
            {
              name: 'Welcome',
              href: '/project-settings',
              icon: WelcomeIcon,
              activeIcon: WelcomeIcon,
            },
            {
              name: 'Overview',
              href: '/project-settings/overview',
              icon: OverViewIcon,
              activeIcon: OverViewIcon,
            },
          ]
        : [
            {
              name: 'Overview',
              href: 'project-settings/',
              icon: OverViewIcon,
              activeIcon: OverViewIcon,
            },
          ]),

      {
        name: 'Rider',
        href: 'project-settings/rider-settings',
        icon: RiderIcons,
        activeIcon: RiderIcons,
      },
      {
        name: 'Merchant',
        href: 'project-settings/merchant-settings',
        icon: MerchantIcon,
        activeIcon: MerchantIcon,
      },
      {
        name: 'Branch',
        href: 'project-settings/branch-settings',
        icon: BranchIcon,
        activeIcon: BranchIcon,
      },
      {
        name: 'Manifest',
        href: 'project-settings/manifest-edit-status',
        icon: ManifestIcon,
        activeIcon: ManifestIcon,
      },
      {
        name: 'Vehicle Manifest',
        href: 'project-settings/vehicle-edit-status',
        icon: ManifestIcon,
        activeIcon: ManifestIcon,
      },
      {
        name: 'Runsheet',
        href: 'project-settings/runsheet-edit-status',
        icon: RunsheetIcon,
        activeIcon: RunsheetIcon,
      },
      {
        name: 'Pickup Request',
        href: 'project-settings/pickuprequest-edit-status',
        icon: PickUpRequest,
        activeIcon: PickUpRequest,
      },
      {
        name: 'RTV/Return',
        href: 'project-settings/rtv-edit-status',
        icon: PickUpRequest,
        activeIcon: PickUpRequest,
      },
      {
        name: 'RTV Branch',
        href: 'project-settings/rtv-edit-branch-status',
        icon: PickUpRequest,
        activeIcon: PickUpRequest,
      },
      {
        name: 'Delivery',
        href: 'project-settings/delivery-edit-status',
        icon: DeliveryIcon,
        activeIcon: DeliveryIcon,
      },
      {
        name: 'Pick & Drop',
        href: 'project-settings/pick&drop-edit-status',
        icon: PickUpRequest,
        activeIcon: PickUpRequest,
      },
      {
        name: 'Website',
        href: 'project-settings/website',
        icon: DeliveryIcon,
        activeIcon: DeliveryIcon,
      },
    ],
  },
];

const DashboardLayout = () => {
  return (
    <DashboardLayoutService navigation={navigation}>
      <div className={tw`h-full p-2 overflow-y-auto`}>
        <Outlet />
      </div>
    </DashboardLayoutService>
  );
};

export default DashboardLayout;
